module.exports = __webpack_public_path__ + "static/media/image-phone.06905d6d.jpg";